import React, { useContext } from 'react';

import { MobilePaymentStatus, PaymentApprovalError } from '../models';

type SigningContextType = {
    status: MobilePaymentStatus | undefined;
    setStatus: (value: MobilePaymentStatus | undefined) => void;
    error: PaymentApprovalError | undefined;
    setError: (value: PaymentApprovalError | undefined) => void;
};

export const SigningContext = React.createContext<SigningContextType | undefined>(undefined);

export const useSigningContext = () => {
    const context = useContext(SigningContext);

    if (context === undefined) {
        throw new Error('useSigningContext must be used within a SigningContextProvider');
    }

    return context;
};
